/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import * as _ from 'lodash';

import {TARGETING_IMPORTS} from '../targeting-imports';

@Component({
  imports: TARGETING_IMPORTS,
  selector: 'adn-targeting-similar-keyword-summary',
  template: '<span *ngFor="let t of target; let last = last"><strong *ngIf="t.negated">NOT </strong>{{t.keyword.word}}<span *ngIf="!last">, </span></span>'
})
export class SimilarKeywordSummaryComponent implements OnChanges {
  @Input() targets: any;

  target: any[] = [];

  ngOnChanges(): void {
    this.target = _.cloneDeep(this.targets) || [];
  }
}
